import {autoRegister, resolve} from "../../container";
import {promiseFromJsonResponse} from "../../common/utils/promises";
import {RequestSugarFactory} from "../common/requestSugar";
import {SecuredRequestExecutor} from "../../module/awswaf/securedRequestExecutor";

export type ChatResponse = {
    message: string;
    previousResponseId: string;
    responseType: string;
}

@autoRegister()
export class GptChatService {

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
    }

    public async postMessage(configId: string, userId: string, userMessage: string, previousResponseId: string, lang: string): Promise<ChatResponse> {
        const postRequest = (): Promise<Response> => fetch(`/enbw-eop/eop-app-gpt-chat/rest/stable/career-gpt/${configId}/${lang}/${previousResponseId}?userId=${userId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({message: userMessage})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }

    public async createChat(configId: string, userId: string, userMessage: string, lang: string): Promise<ChatResponse> {
        const postRequest = (): Promise<Response> => fetch(`/enbw-eop/eop-app-gpt-chat/rest/stable/career-gpt/${configId}/${lang}?userId=${userId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({message: userMessage})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }
}